import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { t } from "../../lang/index";

type Avaliacao = {
    id: number;
    nota: number;
    comentario: string;
    usuarioNome: string;
    usuarioFotoUrl?: string;
    pacoteNome: string;
    pacoteId: number;
};

const TestimonialSection = () => {
    const BASE_URL = process.env.REACT_APP_API_URL;
    const [avaliacoes, setAvaliacoes] = useState<Avaliacao[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAvaliacoes = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/avaliacoes/aprovadas/top`);
                setAvaliacoes(res.data);
            } catch (err) {
                console.error("Erro ao carregar avaliações:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchAvaliacoes();
    }, [BASE_URL]);

    return (
        <section className="section testimonial-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-10 text-center aos" data-aos="fade-up">
                        <div className="section-header text-center">
                            <h2 className="mb-2">
                                {t("home.testimonialSection.title", {
                                    highlight: t("home.testimonialSection.highlight"),
                                })}
                            </h2>
                            <p className="sub-title">
                                {t("home.testimonialSection.subtitle")}
                            </p>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <p className="text-center">{t("home.testimonialSection.loading")}</p>
                ) : avaliacoes.length > 0 ? (
                    <div className="row">
                        {avaliacoes.map((av) => (
                            <div key={av.id} className="col-md-4 col-sm-6 mb-4">
                                <div className="card border-white aos h-100" data-aos="fade-up">
                                    <div className="card-body d-flex flex-column">
                                        <h6 className="mb-3">
                                            <Link
                                                to={`/flight-details/${av.pacoteId}`}
                                                className="text-decoration-none text-primary fw-semibold"
                                                style={{ cursor: "pointer" }}
                                                title={t("home.testimonialSection.viewPackage")}
                                            >
                                                {av.pacoteNome}
                                            </Link>
                                        </h6>
                                        <p className="mb-4 flex-grow-1">
                                            {av.comentario || t("home.testimonialSection.noComment")}
                                        </p>
                                        <div className="border-top pt-3 d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <span className="avatar avatar-md flex-shrink-0">
                                                    <img
                                                        src={
                                                            av.usuarioFotoUrl
                                                                ? `${BASE_URL}${av.usuarioFotoUrl}`
                                                                : "/assets/img/users/default-avatar.png"
                                                        }
                                                        className="rounded-circle"
                                                        alt={av.usuarioNome || "avatar"}
                                                    />
                                                </span>
                                                <div className="ms-2">
                                                    <h6 className="fs-16 fw-medium mb-0">
                                                        {av.usuarioNome}
                                                    </h6>
                                                </div>
                                            </div>
                                            <span className="badge badge-warning badge-xs text-gray-9 fs-13 fw-medium me-2">
                                                {av.nota?.toFixed(1)}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-muted">
                        {t("home.testimonialSection.noReviews")}
                    </p>
                )}
            </div>

            <div className="testimonial-bg">
                <img
                    src="/assets/img/bg/testimonial-bg-01.svg"
                    alt="background"
                />
            </div>
        </section>
    );
};

export default TestimonialSection;